export const pythonEndpoints = {
    anonymousid:
`# set the apikey and limit the # coming back
apikey = "LIVDSRZULELA"  # test value

# first time user, grab and store their the anonymous ID
r = requests.get("https://g.tenor.com/v1/anonid?key=%s" % apikey)

if r.status_code == 200:
    anon_id = json.loads(r.content)["anon_id"]
    # store in db/cookies for re-use later
else:
    anon_id = ""`,

    trendinggifs:
`import requests
import json

# set the apikey and limit
apikey = "LIVDSRZULELA"
lmt = 10


# get the top 10 trending GIFs - using the default locale of en_US
r = requests.get("https://g.tenor.com/v1/trending?key=%s&limit=%s" % (apikey, lmt))

if r.status_code == 200:
    trending_gifs = json.loads(r.content)
else:
    trending_gifs = None

# load the results
print trending_gifs`,

    categories:
`import requests
import json


# set the apikey and limit
apikey = "LIVDSRZULELA"

# get the current list of categories - using the default locale of en_US
r = requests.get("https://g.tenor.com/v1/categories?key=%s" % (apikey,))

if r.status_code == 200:
    categories = json.loads(r.content)
else:
    categories = None

# load the results
print categories`,

    search:
`# set the apikey and limit
apikey = "LIVDSRZULELA"  # test value
lmt = 8

# our test search
search_term = "excited"

# get the top 8 GIFs for the search term using default locale of EN_US
r = requests.get(
    "https://g.tenor.com/v1/search?q=%s&key=%s&limit=%s" % (search_term, apikey, lmt))

if r.status_code == 200:
    # load the GIFs using the urls for the smaller GIF sizes
    top_8gifs = json.loads(r.content)
    print top_8gifs
else:
    top_8gifs = None


# continue a similar pattern until the user makes a selection or starts a new search.`,

    registershare:
`# set the apikey
apikey = "LIVDSRZULELA"  # test value

# get the GIF's id and search used
shard_gifs_id = top_8gifs[0]["id"]

search_term = "excited"

# using default locale of EN_US
r = requests.get("https://g.tenor.com/v1/registershare?id=%s&key=%s&q=%s" % (
shard_gifs_id, apikey, search_term))

if r.status_code == 200:
    pass
    # move on
else:
    pass
    # handle error`,

    autocomplete:
`# set the apikey and limit the # coming back
apikey = "LIVDSRZULELA"  # test value
lmt = 5

# partial search
psearch = "exc"

# using default locale of EN_US
r = requests.get(
    "https://g.tenor.com/v1/autocomplete?key=%s&q=%s&limit=%s" % (apikey, psearch, lmt))

if r.status_code == 200:
    # return the search predictions
    search_term_list = json.loads(r.content)["results"]
    print search_term_list
else:
    # handle a possible error
    search_term_list = []`,

    suggestions:
`# set the apikey and limit the # coming back
apikey = "LIVDSRZULELA"  # test value
lmt = 5

# partial search
search = "excited"

# using default locale of EN_US
r = requests.get(
    "https://g.tenor.com/v1/search_suggestions?key=%s&q=%s&limit=%s" % (apikey, search, lmt))

if r.status_code == 200:
    # return the search suggestions
    search_suggestion_list = json.loads(r.content)["results"]
    print search_suggestion_list
else:
    # handle a possible error
    search_suggestion_list = []`,

    gifs:
`# set the apikey and limit
apikey = "LIVDSRZULELA"  # test value

# our gif id
gifid = 8776030

# get the specific gif
r = requests.get(
    "https://g.tenor.com/v1/gifs?ids=%s&key=%s" % (gifid, apikey))

if r.status_code == 200:
    # load the GIFs using the urls for the smaller GIF sizes
    gifs = json.loads(r.content)
    print gifs
else:
    gifs = None`,

    random:
`# set the apikey and limit
apikey = "LIVDSRZULELA"  # test value
lmt = 8

# our test search
search_term = "excited"

# get random results using default locale of EN_US
r = requests.get(
    "https://g.tenor.com/v1/random?q=%s&key=%s&limit=%s" % (search_term, apikey, lmt))

if r.status_code == 200:
    gifs = json.loads(r.content)
    print gifs
else:
    gifs = None`,

    trendingterms:
`import requests
import json


# set the apikey and limit
apikey = "LIVDSRZULELA"

# get the current list of categories - using the default locale of en_US
r = requests.get("https://g.tenor.com/v1/trending_terms?key=%s" % (apikey,))

if r.status_code == 200:
    trending_terms = json.loads(r.content)
else:
    trending_terms = None

# load the results
print trending_terms`,

    search_stickers:
`# set the apikey and limit
apikey = "LIVDSRZULELA"  # test value
lmt = 10

# our test search
search_term = "excited"

# get the top 8 GIFs for the search term using default locale of EN_US
r = requests.get(
    "https://g.tenor.com/v1/search?searchfilter=sticker&q=%s&key=%s&limit=%s" % (search_term, apikey, lmt))

if r.status_code == 200:
    # load the GIFs using the urls for the smaller GIF sizes
    top_10stickers = json.loads(r.content)
    print top_10stickers
    # print the first webp_transparent sticker asset
    print top_10stickers['results'][0]['media'][0]['webp_transparent']['url']
else:
    top_10stickers = None`,

    trending_stickers:
`import requests
import json

# set the apikey and limit
apikey = "LIVDSRZULELA"
lmt = 10


# get the top 10 trending GIFs - using the default locale of en_US
r = requests.get("https://g.tenor.com/v1/trending?searchfilter=sticker&key=%s&limit=%s" % (apikey, lmt))

if r.status_code == 200:
    trending_stickers = json.loads(r.content)
else:
    trending_stickers = None

# load the results
print trending_stickers`,
};

export const pythonQuickStart = {
    launch:

`import requests
import json

# set the apikey and limit
apikey = "LIVDSRZULELA"
lmt = 10



# get the top 10 trending GIFs - using the default locale of en_US
r = requests.get("https://g.tenor.com/v1/trending?key=%s&limit=%s" % (apikey, lmt))

if r.status_code == 200:
    trending_gifs = json.loads(r.content)
else:
    trending_gifs = None

# get the current list of categories - using the default locale of en_US
r = requests.get("https://g.tenor.com/v1/categories?key=%s" % (apikey,))

if r.status_code == 200:
    trending_terms = json.loads(r.content)
else:
    trending_terms = None

# load some mix of the results below the search bar for the user
# for GIFs use the smaller formats for faster load times
print trending_gifs
print trending_terms`,
    search:

`# set the apikey and limit
apikey = "LIVDSRZULELA"  # test value
lmt = 8

# our test search
search_term = "excited"

# get the top 8 GIFs for the search term
r = requests.get(
    "https://g.tenor.com/v1/search?q=%s&key=%s&limit=%s" % (search_term, apikey, lmt))

if r.status_code == 200:
    # load the GIFs using the urls for the smaller GIF sizes
    top_8gifs = json.loads(r.content)
    print top_8gifs
else:
    top_8gifs = None


# continue a similar pattern until the user makes a selection or starts a new search.
`,
    registershare:

`# set the apikey
apikey = "LIVDSRZULELA"  # test value

# get the GIF's id and search used
shard_gifs_id = top_8gifs[0]["id"]

search_term = "excited"

r = requests.get("https://g.tenor.com/v1/registershare?id=%s&key=%s&q=%s" % (
shard_gifs_id, apikey, search_term))

if r.status_code == 200:
    pass
    # move on
else:
    pass
    # handle error`,
    autocomplete:

`# set the apikey and limit the # coming back
apikey = "LIVDSRZULELA"  # test value
lmt = 5

# partial search
psearch = "exc"

r = requests.get(
    "https://g.tenor.com/v1/autocomplete?key=%s&q=%s&limit=%s" % (apikey, psearch, lmt))

if r.status_code == 200:
    # return the search predictions
    search_term_list = json.loads(r.content)["results"]
    print search_term_list
else:
    # handle a possible error
    search_term_list = []`,
    suggestions:

`# set the apikey and limit the # coming back
apikey = "LIVDSRZULELA"  # test value
lmt = 5

# partial search
search = "smile"

r = requests.get(
    "https://g.tenor.com/v1/search_suggestions?key=%s&q=%s&limit=%s" % (apikey, search, lmt))

if r.status_code == 200:
    # return the search suggestions
    search_suggestion_list = json.loads(r.content)["results"]
    print search_suggestion_list
else:
    # handle a possible error
    search_suggestion_list = []`,
};
